import { createFileRoute } from '@tanstack/react-router';
import { PayoutPage } from '../components/pages/PayoutPage/PayoutPage';
import { z } from 'zod/mini';

const searchSchema = z.object({
  createdAt: z.catch(z.string(), ''),
});

export const Route = createFileRoute('/account/payouts_/$payoutId')({
  component: PayoutPage,
  validateSearch: searchSchema.parse,
});
